module.exports = __webpack_public_path__ + "img/chevron_down_dark_green.afe22a9a.svg";